import React, { useEffect, useState } from 'react';
import './ReserveTable.css';
import ConfirmationPage from './ConfirmationPage';
import { fetchAPI} from '../utils/api';

const ReserveTable = ({ onSubmit }) => {
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    time: '',
    guests: '2',
    occasion: 'casual',
    name: '',
    email: '',
    phone: '',
    specialRequests: ''
  });

  const [availableSlots, setAvailableSlots] = useState([]);
  const [isSubmitted,setIsSubmitted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line no-undef
    const timeSlots = fetchAPI(new Date());
    setAvailableSlots(timeSlots);
  }, [])

 

  const handleDateChange = (e) => {
    const { value } = e.target;

    // eslint-disable-next-line no-undef
    const timeSlots = fetchAPI(new Date(value));
    handleChange(e);
    setAvailableSlots(timeSlots);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit(formData);
    }
    // Handle form submission here
    console.log('Booking submitted:', formData);
    setIsSubmitted(true);
  };

  if (isSubmitted) {
    return <ConfirmationPage reservationDetails={formData} />;
  }

  return (
    <div className="reserve-container" data-testid="reserve-container">
      <div className="reserve-header">
        <h1>Reserve a Table</h1>
        <p>Book your dining experience at Little Lemon</p>
      </div>

      <div className="reserve-content">
        <form className="reserve-form" onSubmit={handleSubmit} data-testid="reserve-form">
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="date">Date</label>
              <input
                type="date"
                id="date"
                name="date"
                value={formData.date}
                onChange={handleDateChange}
                min={new Date().toISOString().split('T')[0]}
                required
                data-testid="date-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="time">Time</label>
              <select
                id="time"
                name="time"
                value={formData.time}
                onChange={handleChange}
                required
                data-testid="time-select"
              >
                <option value="">Select a time</option>
                {availableSlots.map(time => (
                  <option key={time} value={time}>{time}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="guests">Number of Guests</label>
              <select
                id="guests"
                name="guests"
                value={formData.guests}
                onChange={handleChange}
                required
                data-testid="guests-select"
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => (
                  <option key={num} value={num}>{num} {num === 1 ? 'Guest' : 'Guests'}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="occasion">Occasion</label>
              <select
                id="occasion"
                name="occasion"
                value={formData.occasion}
                onChange={handleChange}
                data-testid="occasion-select"
              >
                <option value="casual">Casual Dining</option>
                <option value="birthday">Birthday</option>
                <option value="anniversary">Anniversary</option>
                <option value="business">Business</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                data-testid="name-input"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                data-testid="email-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                data-testid="phone-input"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="specialRequests">Special Requests</label>
            <textarea
              id="specialRequests"
              name="specialRequests"
              value={formData.specialRequests}
              onChange={handleChange}
              rows="4"
              placeholder="Any special requests or dietary requirements?"
              data-testid="special-requests-input"
            ></textarea>
          </div>

          <button type="submit" className="submit-button" data-testid="submit-button">
            Reserve Table
          </button>
        </form>

        <div className="reserve-info" data-testid="reserve-info">
          <h2>Reservation Information</h2>
          <div className="info-item">
            <span className="icon">🕒</span>
            <div>
              <h3>Opening Hours</h3>
              <p>Monday - Friday: 11:00 AM - 10:00 PM</p>
              <p>Saturday - Sunday: 10:00 AM - 11:00 PM</p>
            </div>
          </div>
          <div className="info-item">
            <span className="icon">📞</span>
            <div>
              <h3>Contact</h3>
              <p>Phone: (555) 123-4567</p>
              <p>Email: reservations@littlelemon.com</p>
            </div>
          </div>
          <div className="info-item">
            <span className="icon">ℹ️</span>
            <div>
              <h3>Important Notes</h3>
              <p>• Reservations are required for parties of 6 or more</p>
              <p>• Please arrive 5 minutes before your reservation time</p>
              <p>• Call us for any changes or cancellations</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReserveTable;